import React, { useEffect } from "react";
// styled components
import { Button, Modal, Form, Input, Select } from "antd";
// hooks
import { useDocumentosConvocatoria } from "./useDocumentosConvocatoria";

// models
import { DocumentosBEPS } from "../../../../../models/Beps/documentosbeps.model";
import { useMaestras } from "../../../../../hooks/useMaestras";
import DocumentInput from "../../../../../utils/DocumentInput";
import DocumentosService from "../../../../../api/Documentos/api-documentos";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  documento: DocumentosBEPS;
  setDocumento: any;
  documentos: Array<DocumentosBEPS>;
  setDocumentos: any;
  indexdocumento: number;
}

export const ModalEditarDocumentos: React.FC<IProps> = (props: IProps) => {
  const { obtenerDocGen, documentosGenerales } = useMaestras();

  const { fileInputRef } = useDocumentosConvocatoria();
  //   efects
  useEffect(() => {
    obtenerDocGen();
  }, []);

  //  functions
  const editarFila = () => {
    let infoupdate = [...props.documentos];
    //console.log(infoupdate);

    infoupdate[props.indexdocumento] = props.documento;
    props.setDocumentos(infoupdate);
    props.setVisualizar(false);
    return props.setDocumento({
      nombre: "",
      tipo_documento: "",
      descripcion: "",
      url_documento: "",
    });
  };

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      const { name } = e.target.files[0];
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return props.setDocumento({ ...props.documento, url_documento: data.data });
    }
  };
  // fields
  const fields = [
    { name: "nombre", value: props.documento.nombre },
    { name: "tipo_documento", value: props.documento.tipo_documento },
    { name: "descripcion", value: props.documento.descripcion },
    { name: "url_documento", value: props.documento.url_documento },
  ];
  return (
    <Modal
      className="ant-modal-close-x2"
      title="Editar documentación general"
      visible={props.visualizar}
      onCancel={() => props.setVisualizar(false)}
      width={1400}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.8)",
      }}
      footer={[
        <div key="footer_buttons_documentos" className="container-fluid">
          <Button
            className="button-gray-ghost"
            onClick={() => {
              props.setVisualizar(false);
              return props.setDocumento({
                nombre: "",
                tipo_documento: "",
                descripcion: "",
                url_documento: "",
              });
            }}
          >
            Cerrar
          </Button>
          <Button
            className="button-azul-radius"
            htmlType="submit"
            form="documentosconvocatoriaeditardocumentosbeps"
          >
            Guardar cambios
          </Button>
        </div>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="container-fluid">
        <Form
          name="documentosconvocatoriaeditardocumentosbeps"
          size="large"
          layout="vertical"
          className="width-100"
          onFinish={() => {
            editarFila();
          }}
          fields={fields}
          onFieldsChange={(_, fields: any) => {
            let infoupdate: any = { ...props.documento };
            for (var i in fields) {
              infoupdate[fields[i].name] = fields[i].value;
            }
            props.setDocumento(infoupdate);
          }}
        >
          <div className="row">
            <div className="col-12 col-md-3">
              <Form.Item
                className="no-margin"
                label="Nombre"
                name="nombre"
                rules={[{ required: true, message: "" }]}
              >
                <Input style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-3">
              <Form.Item
                className="no-margin"
                label="Tipo de documento"
                name="tipo_documento"
                rules={[{ required: true, message: "" }]}
              >
                <Select style={{ width: "100%" }} placeholder="Seleccionar..">
                  {documentosGenerales.map(({ id, nombre }: any) => (
                    <Select.Option key={id} value={nombre}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-6">
              <Form.Item
                className="no-margin width-100 height-100"
                label="Adjuntar documento"
                name="url_documento"
              >
                <DocumentInput
                  doc={props.documento.url_documento}
                  fileInputRef={fileInputRef}
                  tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                  // setGuardoArchivo={setGuardoArchivo}
                  on_change={(e) => {
                    guardarArchivo(e);
                    e.target.value = "";
                  }}
                  onDelete={() =>
                    props.setDocumento({
                      ...props.documento,
                      url_documento: "",
                    })
                  }
                />
              </Form.Item>
            </div>
            <div className="col-12">
              <Form.Item
                className="no-margin"
                label="Descripción"
                name="descripcion"
                rules={[{ required: true, message: "" }]}
              >
                <Input.TextArea
                  showCount={true}
                  maxLength={300}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </div>
            {/* <div className="col-12 col-md-6 pe-4 ps-4">
              <div className="row">
                <Form.Item
                  className="no-margin width-100 height-100"
                  label="Adjuntar documento"
                  name="url_documento"
                  rules={[{ required: true, message: "" }]}
                >
                  <Row
                    className="justify-content-center height-100"
                    style={{
                      backgroundColor: "#F6F6F6",
                      borderRadius: "11px",
                      border: "1px solid #707070",
                      alignItems: "center",
                    }}
                  >
                    {props.documento.url_documento === "" ? (
                      <>
                        <Button
                          className="button-azul-ghost-gray-background"
                          onClick={() => fileInputRef.current.click()}
                        >
                          Seleccionar archivo
                        </Button>
                        <input ref={fileInputRef} type="file" hidden onChange={(e) => {
                          guardarArchivo(e);
                          e.target.value = ""
                        }} />
                      </>
                    ) : (
                      <>
                        <span>{props.documento.url_documento}</span>
                        <Button
                          className="button-rojo-ghost"
                          onClick={() => props.setDocumento({ ...props.documento, url_documento: "" })}
                        >
                          Eliminar
                        </Button>
                      </>
                    )}
                  </Row>
                </Form.Item>
              </div>
            </div> */}
          </div>
        </Form>
      </div>
    </Modal>
  );
};
